import React from 'react';

const Header = () => {
  return (
    <div id="header-banner" className="mb-[10px]">
      <div className="portlet-boundary portlet-boundary_com_liferay_journal_content_web_portlet_JournalContentPortlet_ portlet-static portlet-static-end portlet-barebone portlet-journal-content">
        <section className="portlet">
          <div className="portlet-content">
            <h2 className="portlet-title-text">HEADER</h2>
            <div className="portlet-content-container">
              <div className="portlet-body">
                <div className="journal-content-article">
                  <a href="https://www.pnj.com.vn/dich-vu-giao-hang-nhanh-pnjfast" target="_blank" rel="noopener noreferrer">
                    <img 
                      src="https://cdn.pnj.io/images/gold-price/banner.jpg" 
                      style={{width: '100%', height: '100%'}} 
                      alt="PNJ Fast Delivery"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Header; 